/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

import { Loader, RootState, TrainingTypesResponse } from 'src/store/types';

export const getTrainingTypesLoader = (state: RootState): Loader =>
  state.trainingTypeListing.loader;
export const getTrainingTypes = (state: RootState): TrainingTypesResponse =>
  state.trainingTypeListing.trainingTypes;
